









import { Component, Vue, PropSync, Emit, Prop } from 'vue-property-decorator';
import ResetPasswordModal from '../reset-password/ResetPasswordModal.vue';
import * as userService from '@/services/user/index';
import Loading from '@/components/loading/Loading.vue';

@Component({
  name: 'ResetPasswordModalController',
  components: {
    ResetPasswordModal,
    loading: Loading,
  }
})
export default class ResetPasswordModalController extends Vue {

  @PropSync("modalState", { type: Boolean, default: false }) 
  private modal !: boolean;

  private isLoading = false;
  private response: string | undefined = "";

  private closeResetPassword() {
    this.$emit('oncancel');
    this.isLoading = false;
    this.response = "";
  }


  private async resetPassword(userInfo: string) {
    this.isLoading = true;
    this.response = await userService.resetPassword(userInfo);
   
    this.isLoading = false;
  }
}
